<template>
    <ViewNavBar />
    <div class="ufo--portfolio-page" :class="[!portfolio.templateSettings.theme.includes('profile_') ? portfolio.templateSettings.theme : null ]">
        <SectionLoader :sections="project.sections" />
        <div class="scroll-to-top" @click="scrollToTop" :class="{'nav-on': portfolio.settings && portfolio.settings.showNavOnCollectionItems }"></div>
    </div>
</template>

<script>
import {useHead} from '@unhead/vue'
import SectionLoader from "./sections/SectionLoader.vue";
import {resolveColor} from "@/scripts/common/helpers.js";
import ViewNavBar from "./ViewNavBar.vue";
import {mapGetters} from "vuex";
import {injectCssVars} from "@/scripts/common/utilities/cssVars.js";
import {buildPortfolioSocialHead} from "./socialHead.js";
import {templatePreviewMixin} from "@/scripts/adminSite/aiPortfolioGenerator/templatePreviewMixin.js";

let myPageHead = null;

export default {
    name: "ProjectView",
    mixins: [templatePreviewMixin],
    components: {
        ViewNavBar,
        SectionLoader,
    },
    beforeMount() {
        injectCssVars(this.getAllCssVars);
    },
    mounted() {
        myPageHead = useHead(() => this.headTags);

        this.$nextTick(() => {
            document.addEventListener('scroll', this.scrollDistance);
        })
    },
    unmounted() {
        myPageHead?.dispose();
    },
    methods: {
        resolveColor,
        scrollToTop() {
            let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
            if (isSmoothScrollSupported) {
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            } else {
                this.smoothScroll(0, -1);
            }
        },
        smoothScroll(targetOffset, direction) {
            let currentOffset = window.pageYOffset || document.body.scrollTop;
            let difference = Math.abs(currentOffset - targetOffset);
            if (!difference) return;
            let frames = parseInt(400 / 1000 * 60);
            let tick = 400 / frames;
            let perFrame = difference / frames;
            let timer = setInterval(() => {
                if (direction > 0) {
                    if (window.pageYOffset >= targetOffset) {
                        scrollBy(0, (targetOffset - difference) * direction);
                        clearInterval(timer);
                        return;
                    }
                } else {
                    if (window.pageYOffset <= 0) {
                        scrollBy(0, difference * direction);
                        clearInterval(timer);
                        return;
                    }
                }
                scrollBy(0, perFrame * direction);
                if (window.pageYOffset + window.innerHeight === document.body.scrollHeight) clearInterval(timer);
            }, tick);
        },
        scrollDistance() {
            if (window.pageYOffset > 1200) {
                if(document.querySelector('.scroll-to-top')?.classList.contains('visible')) return;
                document.querySelector('.scroll-to-top')?.classList.add("visible");
            } else {
                document.querySelector('.scroll-to-top')?.classList.remove("visible");
            }
        },
    },
    computed: {
        ...mapGetters("design", ["getAllCssVars"]),
        ...mapGetters("view", ["viewData"]),
        portfolio() {
            return this.viewData.portfolio
        },
        socialHead() {
            return buildPortfolioSocialHead({
                portfolio: this.portfolio,
                project: this.project,
                user: this.user,
                route: this.$route,
                useProjectSocialInfo: true,
            });
        },
        headTags() {
            return this.socialHead;
        },
        project() {
            return this.viewData.project
        },
        user() {
            return this.viewData.user
        },
        portfolioPages() {
          return this.viewData.portfolioPages
        },
    }
}
</script>
